import { render, staticRenderFns } from "./AssignDepotToUnitsDialog.vue?vue&type=template&id=22f8a77a"
import script from "./AssignDepotToUnitsDialog.vue?vue&type=script&lang=js"
export * from "./AssignDepotToUnitsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports